import { Box, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ptBR from "date-fns/locale/pt-BR";

const DateRangeSelector = ({ startDate, endDate, onChange }) => {
  const handleStartDateChange = (date) => {
    onChange({ startDate: date, endDate });
  };

  const handleEndDateChange = (date) => {
    onChange({ startDate, endDate: date });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
      <Box sx={{ display: "flex", gap: 2 }}>
        <DatePicker
          label="Data Inicial"
          value={startDate}
          onChange={handleStartDateChange}
          renderInput={(params) => <TextField {...params} fullWidth />}
          inputFormat="dd/MM/yyyy"
        />
        <DatePicker
          label="Data Final"
          value={endDate}
          onChange={handleEndDateChange}
          renderInput={(params) => <TextField {...params} fullWidth />}
          inputFormat="dd/MM/yyyy"
        />
      </Box>
    </LocalizationProvider>
  );
};

export default DateRangeSelector;
